import { SET_SEGMENTS, SET_DISTRIBUTED_SHOT_DURATIONS } from '../actions/segments';
import { Segment } from '../types/segments';
import type { SegmentsState } from '../types/segments';

export const initialSegmentsState: SegmentsState = {
	segments: [],
	distributedShotDurations: {},
};

interface Action {
	type: string;
	payload: any;
}

const actions: Map<string, (state: SegmentsState, action: Action) => SegmentsState> = new Map([
	[
		SET_SEGMENTS,
		(state, action): SegmentsState => ({
			...state,
			segments: action.payload,
		}),
	],
	[
		SET_DISTRIBUTED_SHOT_DURATIONS,
		(state, action): SegmentsState => ({
			...state,
			distributedShotDurations: action.payload,
		}),
	],
]);

export const SegmentsReducer = (state: SegmentsState = initialSegmentsState, action: Action): SegmentsState =>
	actions.get(action.type)?.(state, action) ?? state;
